module.exports = __webpack_public_path__ + "static/media/bg-login.39e1ba29.jpg";